<!-- eslint-disable prettier/prettier -->
<template>
  <div class="grid grid-cols-1 gap-y-2">
    <div
v-if="technicalPhone || technicalEmail"
      class="text-sm font-bold text-[color:var(--color-footer-top-text)]">{{
        $t('shared.layout.footer.technicalsupport') }}</div>
    <a
v-if="technicalPhone"
      class="footer-link text-sm font-medium text-[color:var(--color-footer-top-link)] hover:text-[color:var(--color-footer-top-link-hover)]"
      :href="`tel:${technicalPhone}`"
      @click="gtmSendGenerateLeadEvent('FooterContactUsTechnicalPhone')">
      {{ technicalPhone }}
    </a>
    <a
v-if="technicalEmail"
      class="footer-link truncate text-sm font-medium text-[color:var(--color-footer-top-link)] hover:text-[color:var(--color-footer-top-link-hover)]"
      :href="`mailto:${technicalEmail}`"
      @click="gtmSendGenerateLeadEvent('FooterContactUsTechnicalEmail')">
      {{ technicalEmail }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { useThorlabsGtm } from "@/shared/gtm/gtm";

interface Props {
  technicalPhone?: string;
  technicalEmail?: string;
}

defineProps<Props>();

const { gtmSendGenerateLeadEvent } = useThorlabsGtm();
</script>
